import axios from './base'
const url = ``

export function index(params = {}) {
  return axios.request({
    url: `${url}/index`,
    method: "get",
    params,
  })
}

export function getLanguage(params = {}){
  return axios.request({
    url: `${url}/../language`,
    method: "get",
    params,
  })
}

export function getInited(params = {}) {
  return axios.request({
    url: `${url}/inited`,
    method: "get",
    params,
  })
}

export function login(data = {}) {
  return axios.request({
    url: `${url}/login`,
    method: "post",
    data: data,
  })
}

// 获取图片验证码：GET /admin/captcha
// 返回 { code:200, data:{ key, image:'data:image/png;base64,...' }, expire:120, msg:'' }
// key 需随登录请求带回后端做校验（字段 captcha_key），image 直接作为 <img> 的 src
export function getCaptcha(params = {}) {
  return axios.request({
    url: `${url}/captcha`,
    method: "get",
    params,
  })
}

// 获取菜单树：GET /admin/menu（需登录，自动带 Authorization）
// 返回 { code:200, data:[菜单树], msg:'' }，节点含 path/name/icon/component/children
export function getMenu(params = {}) {
  return axios.request({
    url: `${url}/admin/menu`,
    method: "get",
    params,
  })
}

// 获取角色权限：GET /admin/permission（需登录，自动带 Authorization）
// 返回 { code:200, data:{ roles:[...], permissions:[...] }, msg:'' }
export function getPermission(params = {}) {
  return axios.request({
    url: `${url}/admin/permission`,
    method: "get",
    params,
  })
}

// 登录态自检：GET /admin/is-login（不依赖有效 token，自行读 Authorization 头）
// 返回 { code:200, data:{ loggedIn:true, user:{...} } } / code:100017(过期) / code:100001(无效)
export function isLogin(params = {}) {
  return axios.request({
    url: `${url}/admin/is-login`,
    method: "get",
    params,
  })
}

export function getProvince(data = {}){
  return axios.request({
    url: `${url}/provinces`,
    method: 'get',
    params: data
  })
}

export function getCity(id,data = {}){
  return axios.request({
    url: `${url}/cities/${id}`,
    method: 'get',
    params: data
  })
}

export function getArea(id,data = {}){
  return axios.request({
    url: `${url}/areas/${id}`,
    method: 'get',
    params: data
  })
}

export function getQiniuToken(data){
  return axios.request({
    url: `${url}/cdn/token`,
    method: 'post',
    data: data
  })
}

export function tencentAddressKeyword(params={}){
  return axios.request({
    url: `${url}/address/keyword`,
    method: 'get',
    params: params
  }) 
}

